/* ID2 B2: returns and warranty in a sheet, without leaving the product. Loaded (deferred) by snippets/umbra-policy-sheet.liquid
   only when the theme setting umbra_policy_sheet is on and a page was found. The page HTML sits inert in a <template>
   (nothing is parsed, laid out or requested at load); the sheet is built on the first tap. The links keep their href, so
   with no script, a modifier-click or a middle click they still go to the full page. A phone gets a bottom sheet, 770 px
   and up a side panel (CSS in the snippet). Esc, the backdrop and the close button dismiss it, focus is trapped and
   goes back to the link, and the page is locked the way the drawers lock it (window.UmbraScrollLock). */
(function () {
  if (window.UmbraPolicySheet) return;
  var KEY = 'policy-sheet';
  var sheet = null;
  var opener = null;
  var lockedByFallback = false;
  var fallbackY = 0;

  function slice(tpl, frag) {
    var root = tpl.content.cloneNode(true);
    var holder = document.createElement('div');
    holder.appendChild(root);
    /* Store page HTML is cloned into the live document: no script, style, link or meta may come along. */
    holder.querySelectorAll('script,style,link,meta').forEach(function (n) { n.remove(); });
    if (frag) {
      var start = null;
      try { start = holder.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(frag) : frag)); } catch (e) { start = null; }
      if (start) {
        while (start.parentNode !== holder && start.parentNode) start = start.parentNode;
        var out = document.createElement('div');
        var level = /^H([1-6])$/.test(start.tagName) ? +start.tagName.charAt(1) : 0;
        var node = start;
        while (node) {
          if (node !== start && level) {
            var m = /^H([1-6])$/.exec(node.tagName || '');
            if (m && +m[1] <= level) break;
          }
          var next = node.nextSibling;
          out.appendChild(node);
          node = next;
        }
        return out;
      }
    }
    return holder;
  }

  function focusables() {
    return sheet.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
  }

  function lock() {
    if (window.UmbraScrollLock) {
      window.UmbraScrollLock.lock(KEY);
    } else {
      fallbackY = window.scrollY;
      document.body.classList.add('fixed');
      document.body.style.top = '-' + fallbackY + 'px';
      lockedByFallback = true;
    }
  }

  function unlock() {
    if (window.UmbraScrollLock) {
      window.UmbraScrollLock.unlock(KEY);
    } else if (lockedByFallback) {
      document.body.classList.remove('fixed');
      document.body.style.top = '';
      window.scrollTo(0, fallbackY);
      lockedByFallback = false;
    }
  }

  function onKey(e) {
    if (!sheet || sheet.hidden) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (!sheet.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    }
  }

  function close() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    sheet.hidden = true;
    document.removeEventListener('keydown', onKey, true);
    unlock();
    if (opener && document.contains(opener)) {
      try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
    }
    opener = null;
  }

  function open(link, tpl) {
    var frag = tpl.getAttribute('data-frag') || '';
    if (sheet) sheet.remove();
    sheet = document.createElement('div');
    sheet.className = 'umbra-ps';
    sheet.innerHTML =
      '<div class="umbra-ps__backdrop" data-ps-close></div>' +
      '<div class="umbra-ps__panel" role="dialog" aria-modal="true" aria-labelledby="umbra-ps-title" tabindex="-1">' +
      '<div class="umbra-ps__head"><h2 class="umbra-ps__title" id="umbra-ps-title"></h2>' +
      '<button type="button" class="umbra-ps__close" data-ps-close></button></div>' +
      '<div class="umbra-ps__body"></div>' +
      '<div class="umbra-ps__foot"><a class="umbra-ps__full"></a></div></div>';
    var panel = sheet.querySelector('.umbra-ps__panel');
    sheet.querySelector('.umbra-ps__title').textContent = tpl.getAttribute('data-title') || link.textContent;
    var closeBtn = sheet.querySelector('.umbra-ps__close');
    closeBtn.setAttribute('aria-label', tpl.getAttribute('data-close') || 'Close');
    closeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    sheet.querySelector('.umbra-ps__body').appendChild(slice(tpl, frag));
    var full = sheet.querySelector('.umbra-ps__full');
    full.href = link.getAttribute('href');
    full.textContent = tpl.getAttribute('data-full') || link.textContent;
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-ps-close]')) close();
    });
    document.body.appendChild(sheet);
    opener = link;
    lock();
    document.addEventListener('keydown', onKey, true);
    /* two frames so the transition runs from the closed state */
    window.requestAnimationFrame(function () {
      sheet.classList.add('is-open');
      closeBtn.focus({ preventScroll: true });
    });
    return panel;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('a[data-umbra-ps]');
    if (!link) return;
    var tpl = document.getElementById(link.getAttribute('data-umbra-ps'));
    if (!tpl || !tpl.content) return;
    e.preventDefault();
    open(link, tpl);
  });

  window.UmbraPolicySheet = { close: close };
}());
